module.exports = __webpack_public_path__ + "static/media/eyes.2b237057.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/eyes.png
// module id = 34
// module chunks = 0